<div class="store-drawer" *ngIf="open">
  <div class="store-drawer__overlay" (click)="closed.emit()" aria-hidden="true"></div>

  <aside #panel class="store-drawer__panel" role="dialog" aria-modal="true"
    aria-labelledby="storeCartTitle">
    <header class="store-drawer__header">
      <h2 class="store-drawer__title" id="storeCartTitle">
        {{ 'clicStore.myCart' | translate }}
        <span class="store-drawer__count">({{ totalItems }})</span>
      </h2>
      <button #closeButton type="button" class="store-drawer__close" (click)="closed.emit()"
        [attr.aria-label]="'clicStore.close' | translate">&times;</button>
    </header>

    <div class="store-drawer__body">
      <p class="store-drawer__empty" *ngIf="isEmpty">{{ 'clicStore.emptyCart' | translate }}</p>

      <ul class="store-drawer__list" *ngIf="!isEmpty">
        <li class="store-drawer__item" *ngFor="let item of items; trackBy: trackByAwardId">
          <img class="store-drawer__thumb" [src]="item.image || placeholder" [alt]="item.name"
            (error)="onImageError($event)">

          <div class="store-drawer__info">
            <p class="store-drawer__name">{{ item.name }}</p>
            <p class="store-drawer__unit">
              {{ item.unitValue | number }}
              {{ (item.unitValue === 1 ? 'clicStore.pointUnitSingular' : 'clicStore.pointsUnit') | translate }}
              / {{ 'clicStore.unitShort' | translate }}
            </p>

            <div class="store-drawer__stepper">
              <button type="button" class="store-drawer__step" (click)="decrement.emit(item.awardId)"
                [attr.aria-label]="('clicStore.decreaseOf' | translate) + ' ' + item.name">&minus;</button>
              <span class="store-drawer__qty" aria-live="polite">{{ item.quantity }}</span>
              <button type="button" class="store-drawer__step" (click)="increment.emit(item.awardId)"
                [disabled]="item.quantity >= item.maxQuantity"
                [title]="item.quantity >= item.maxQuantity ? ('clicStore.stockLimit' | translate) : ''"
                [attr.aria-label]="('clicStore.increaseOf' | translate) + ' ' + item.name">+</button>
            </div>
          </div>

          <div class="store-drawer__right">
            <button type="button" class="store-drawer__remove" (click)="removed.emit(item.awardId)"
              [attr.aria-label]="('clicStore.removeOf' | translate) + ' ' + item.name">
              <img src="assets/images/thrash.svg" alt="">
            </button>
            <strong class="store-drawer__subtotal">
              {{ subtotal(item) | number }}
              <span>{{ 'clicStore.pointsUnit' | translate }}</span>
            </strong>
          </div>
        </li>
      </ul>
    </div>

    <footer class="store-drawer__footer" *ngIf="!isEmpty">
      <dl class="store-drawer__summary">
        <div class="store-drawer__row">
          <dt>{{ 'clicStore.myPointsLabel' | translate }}</dt>
          <dd>{{ balance | number }} {{ 'clicStore.pointsUnit' | translate }}</dd>
        </div>
        <div class="store-drawer__row">
          <dt>{{ 'clicStore.exchangeTotal' | translate }}</dt>
          <dd class="store-drawer__row--debit">
            &minus;{{ total | number }} {{ 'clicStore.pointsUnit' | translate }}
          </dd>
        </div>
        <div class="store-drawer__row store-drawer__row--strong">
          <dt>{{ 'clicStore.balanceAfter' | translate }}</dt>
          <dd>{{ balanceAfter | number }} {{ 'clicStore.pointsUnit' | translate }}</dd>
        </div>
      </dl>

      <div class="store-drawer__field">
        <label for="storeCartPhone">{{ 'clicStore.phoneLabel' | translate }}</label>
        <input id="storeCartPhone" type="tel" inputmode="numeric" mask="(00) 00000-0000"
          placeholder="(00) 00000-0000" [ngModel]="phone" (ngModelChange)="onPhoneInput($event)"
          [class.is-invalid]="phoneTouched && !phoneValid"
          [attr.aria-invalid]="phoneTouched && !phoneValid">
        <p class="store-drawer__error" *ngIf="phoneTouched && !phoneValid">
          {{ 'clicStore.phoneRequired' | translate }}
        </p>
      </div>

      <p class="store-drawer__block" *ngIf="blockReason">{{ blockReason | translate }}</p>

      <button type="button" class="store-drawer__confirm" (click)="onConfirm()"
        [disabled]="submitting || isEmpty || !!blockReason">
        {{ (submitting ? 'clicStore.confirming' : 'clicStore.confirmExchange') | translate }}
      </button>

      <button type="button" class="store-drawer__keep" (click)="closed.emit()">
        {{ 'clicStore.keepChoosing' | translate }}
      </button>
    </footer>
  </aside>
</div>
